// Apolo IDE — AutoReviewMetricsIndicator (S4 · E5-WS1-T03).
//
// Discreet, local-only indicator of "% blocked / % interrupted turns". Counts
// only — no PII. Hidden entirely when nothing was reviewed (stays out of the way).

import { ShieldAlert, ShieldCheck } from 'lucide-react';

const pct = (x) => `${Math.round((Number(x) || 0) * 100)}%`;

/**
 * @param {{ metrics?: { total?:number, blockedRate?:number, interruptedTurnRate?:number, interrupted?:boolean } }} props
 */
export function AutoReviewMetricsIndicator({ metrics }) {
  const m = metrics || {};
  const blockedRate = Number(m.blockedRate) || 0;
  const interruptRate = m.interruptedTurnRate != null
    ? (Number(m.interruptedTurnRate) || 0)
    : (m.interrupted ? 1 : 0);
  const total = Number(m.total) || 0;

  // Discreet: render nothing until there's something to report.
  if (total === 0 && blockedRate === 0 && interruptRate === 0) return null;

  // Neutral icon when there is no block signal (a warning icon at 0% reads as a
  // false alarm); alarming only when blocks actually happened.
  const hasSignal = blockedRate > 0;
  const Icon = hasSignal ? ShieldAlert : ShieldCheck;

  return (
    <div
      data-testid="auto-review-metrics"
      title="Auto-review desta sessão (local, sem PII)"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        fontSize: 10, color: 'var(--rx-tx3)', fontFamily: 'var(--rx-mono)',
      }}
    >
      <Icon size={11} aria-hidden="true" style={{ color: hasSignal ? 'var(--rx-gold)' : 'var(--rx-tx4)' }} />
      <span>{pct(blockedRate)} bloqueado</span>
      <span style={{ color: 'var(--rx-tx3)' }}>·</span>
      <span>{pct(interruptRate)} interrupção</span>
    </div>
  );
}

export default AutoReviewMetricsIndicator;
